import type { ElectronAPI } from './types';

/** True only inside the real Electron shell (preload injects electronAPI). Never use VITE_DESKTOP here — that flag is build-time and must not break the web app. */
export function isDesktopApp(): boolean {
  return Boolean(typeof window !== 'undefined' && window.electronAPI?.isDesktop);
}

export function getElectronAPI(): ElectronAPI | null {
  return window.electronAPI || null;
}
